/* global MicroModal */
MicroModal.init({
  disableFocus: true,
});

function triggerModal(modalId) {
  MicroModal.show(modalId);
}

const reminder = document.querySelector('input[id="reminder"]')
if(reminder) {
  reminder.addEventListener('change', function () {
    const emailField = document.getElementById('email-field');
    emailField.style.display = this.checked ? 'block' : 'none';
  });
}

